import { format } from 'date-fns'
import { DATE_FORMAT } from '../../date-formatting.js'
import { configApi } from '../../http-client.js'

export const getCookieBanners = () => configApi.get('/api/CookieBanner').then(({ data: { cookieBanners } }) => ({
	cookieBanners: cookieBanners.map(banner => ({
		...banner,
		mspaMode: banner.mspaOptOutOptionMode === 1 && banner.mspaServiceProviderMode === 0
			? 1
			: banner.mspaOptOutOptionMode === 0 && banner.mspaServiceProviderMode === 1 ? 2 : null,
		enableCis: banner.identityServiceEnabled,
		allowedDomainsValue: banner.allowedDomains === null || banner.allowedDomains?.length === 0 || banner.allowedDomains?.toLowerCase() === 'all',
		allowedDomains: banner.allowedDomains?.length > 0 ? banner.allowedDomains?.split(',') : [],
		createdDate: format(new Date(banner.createdDate), DATE_FORMAT),
		metaData: banner.metaData.map(metadata => ({
			metaDataKeyId: metadata.keyId,
			metaDataValue: metadata.value,
			metaDataKeyName: metadata.keyName,
			valueId: metadata.valueId
		}))
	}))
}))

// Transform mspaMode to mspaOptOutOptionMode and mspaServiceProviderMode on create/edit banners
export const postCookieBanner = cookieBanner => {
	const transformedBanner = { ...cookieBanner, mspaOptOutOptionMode: 0, mspaServiceProviderMode: 0 }
	if (transformedBanner.mspaMode === 1) {
		transformedBanner.mspaOptOutOptionMode = 1
	} else if (transformedBanner.mspaMode === 2) {
		transformedBanner.mspaServiceProviderMode = 1
	}
	delete transformedBanner.mspaMode

	return configApi.post('/api/CookieBanner', transformedBanner)
}

export const putCookieBanner = cookieBanner => {
	const transformedBanner = { ...cookieBanner, mspaOptOutOptionMode: 0, mspaServiceProviderMode: 0 }
	if (transformedBanner.mspaMode === 1) {
		transformedBanner.mspaOptOutOptionMode = 1
	} else if (transformedBanner.mspaMode === 2) {
		transformedBanner.mspaServiceProviderMode = 1
	}
	delete transformedBanner.mspaMode

	return configApi.put('/api/CookieBanner', transformedBanner)
}

export const deleteCookieBanner = cookieBannerId => configApi.delete(`/api/CookieBanner/${cookieBannerId}`)

export const cookieBannerForceReconsent = cookieBannerId => configApi.get(`/api/CookieBanner/RequestReconsent/${cookieBannerId}`)

export const getCookieBannerEmbedCode = (cookieBannerId, languageCode, domain, dynamic) => {
	let embedCodeEndpoint = `/api/CookieBanner/EmbedCode?CookieBannerId=${cookieBannerId}`
	if (languageCode) embedCodeEndpoint += `&LanguageCode=${languageCode}`
	if (domain) embedCodeEndpoint += `&Domain=${domain}`
	if (dynamic) embedCodeEndpoint += `&Dynamic=${dynamic}`
	return configApi.get(embedCodeEndpoint)
}
